import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';
import $ from 'jquery';

/* Actions */
import * as entityUseQueryActions from '../../actions/entityUseQuery/index';

/*Components*/
import EntityUseQueryPopup from '../../components/entityUseQuery/entityUseQueryPopup';

class EntityUseQuery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValues: {
        entityType: "",
        entityValue: ""
      }
    };
  }
 
  componentDidUpdate(prevProps) {
    if(!InterfaceTooling.popupHasToRender(prevProps.popupState) && 
       InterfaceTooling.popupHasToRender(this.props.popupState)) {
      if(!this.props.providedDimensionsList) {
        this.props.actions.getDimensionsList();
      }
      if(!this.props.providedMetricsList) {
        this.props.actions.getMetricsList();
      }
      if(!this.props.providedPolynomialsList) {
        this.props.actions.getPolynomilasList();
      }
      this.setState({
        filterValues: {
          entityType: this.props.entityDefaultType,
          entityValue: this.props.entityDefaultId
        }
      });      
      this.props.actions.getEntityQuery({
        type: this.props.entityDefaultType,
        id: this.props.entityDefaultId
      });
    }
  }

  handleOnChangeFilters = (event) => {    
    let path = event.currentTarget.dataset.path;
    let value = event.currentTarget.value;
    let newFilterValues = JavascriptUtilsTooling.deepCopy(this.state.filterValues);
    newFilterValues[path] = value;
    if(path=="entityType") {
      newFilterValues.entityValue = ""
    }
    else if(path=="entityValue" && newFilterValues.entityValue && newFilterValues.entityType) {
      this.props.actions.getEntityQuery({
        type: newFilterValues.entityType,
        id: newFilterValues.entityValue
      });
    }
    this.setState({
      filterValues: newFilterValues
    });
  };

  render() {
    const {
      handleEntityQueryDataPopup,
      entityDefaultType,
      entityDefaultId,
      providedDimensionsList,
      providedMetricsList,
      providedPolynomialsList,
      popupState
    } = this.props;
    let loadingDimensions = providedDimensionsList ? false : this.props.dimensionsList.loading;
    let loadingMetrics = providedMetricsList ? false : this.props.metricsList.loading;
    let loadingPolynomials = providedPolynomialsList ? false : this.props.polynomialsList.loading;
    return (
        <EntityUseQueryPopup
          handleShowPopup={handleEntityQueryDataPopup}
          handleOnChangeFilters={this.handleOnChangeFilters}
          filterValues={this.state.filterValues}
          queryData={this.props.queryData.data}
          queryStatus={this.props.queryData.status}
          dimensionsListData={providedDimensionsList ? providedDimensionsList : this.props.dimensionsList.data}
          metricsListData={providedMetricsList ? providedMetricsList : this.props.metricsList.data}
          polynomialsListData={providedPolynomialsList ? providedPolynomialsList : this.props.polynomialsList.data}
          fullLoading={this.props.queryData.loading || loadingDimensions  || 
            loadingMetrics || loadingPolynomials}
          popupState={popupState}
        />
    );
  }
}

const mapStateToProps = state => ({
  queryData: state.reducer.entityUseQuery.queryData,
  dimensionsList: state.reducer.entityUseQuery.dimensionsList,
  metricsList: state.reducer.entityUseQuery.metricsList,
  polynomialsList: state.reducer.entityUseQuery.polynomialsList
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(entityUseQueryActions, dispatch)
});

EntityUseQuery.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EntityUseQuery);



// WEBPACK FOOTER //
// ./source/client/containers/entityUseQuery/index.jsx